/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Mapping_Search_ErpInputs */

const vi_kiotviet_mapping_search_erp = /** @type {(inputs: Kiotviet_Mapping_Search_ErpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm sản phẩm ERP…`)
};

/**

* @param {Kiotviet_Mapping_Search_ErpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_mapping_search_erp = /** @type {((inputs?: Kiotviet_Mapping_Search_ErpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Mapping_Search_ErpInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_mapping_search_erp(inputs)
});